import { Controller } from "@hotwired/stimulus";
import { driver } from "driver.js";

// Visite guidée (onboarding) — enrobe driver.js et l'habille au Design System GO4S.
//
// Valeurs (injectées par shared/ds/_guided_tour) :
//   key, version, seen, autostart, completeUrl, steps[], next, prev, done
//
// Comportement :
//   - lancement AUTO à la première visite (autostart && !seen) ;
//   - relançable à la demande via l'action `ds-tour#start` (bouton « ? ») ;
//   - responsive-aware : on saute les étapes dont la cible est absente/cachée
//     (ex. la sidebar repliée en drawer mobile) ;
//   - à la fin, on enregistre « vu » côté serveur (table user_tours).
export default class extends Controller {
  static values = {
    key: String,
    version: Number,
    seen: Boolean,
    autostart: Boolean,
    completeUrl: String,
    steps: Array,
    next: { type: String, default: "Suivant" },
    prev: { type: String, default: "Précédent" },
    done: { type: String, default: "Terminé" },
  };

  connect() {
    if (this.autostartValue && !this.seenValue) {
      // petit délai : laisse le DOM et les frames lazy se poser
      this.timer = setTimeout(() => this.start(), 700);
    }
  }

  disconnect() {
    clearTimeout(this.timer);
    this.driverObj?.destroy();
  }

  start() {
    const steps = this.#buildSteps();
    if (!steps.length) return;

    this.driverObj = driver({
      showProgress: true,
      progressText: "{{current}} / {{total}}",
      allowClose: true,
      overlayColor: "rgba(15, 26, 36, 0.55)",
      stagePadding: 6,
      stageRadius: 12,
      popoverClass: "ds-tour-popover",
      nextBtnText: this.nextValue,
      prevBtnText: this.prevValue,
      doneBtnText: this.doneValue,
      steps,
      onDestroyed: () => this.#markSeen(),
    });

    this.driverObj.drive();
  }

  // Construit les étapes driver.js, en filtrant les cibles absentes/cachées.
  #buildSteps() {
    return this.stepsValue
      .map((s) => {
        const popover = {
          title: s.title,
          description: s.body,
          side: s.side || "bottom",
          align: "start",
        };

        if (!s.element) return { popover }; // étape centrée (intro)

        const el = document.querySelector(s.element);
        if (!el) return null;

        const r = el.getBoundingClientRect();
        if (r.width === 0 && r.height === 0) return null; // caché (drawer mobile…)

        return { element: el, popover };
      })
      .filter(Boolean);
  }

  #markSeen() {
    if (!this.completeUrlValue) return;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    fetch(this.completeUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token || "",
      },
      body: JSON.stringify({ version: this.versionValue }),
    }).catch(() => {});
  }
}
